import { axiosInstance, baseUrl, handleErrors } from "./auth";




export const GET_TREATMENT_PLACE_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/treatmentplan/listTreatmentPlace`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

export const GENERATE_CLAIM_FORM = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/generateClaimForm`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}


export const PATIENT_DETAILS_SUPERBILL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/superbill/patientDetailsForBill`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

export const LIST_PATIENT_DETAILS_SUPERBILL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/superbill/listSuperBill`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

export const PATIENT_DETAILS_SUPERBILL_GENERATE = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/superbill/generate`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}


export const GET_PATIENT_DETAILS_SUPERBILL = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/superbill/${params}`);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}


export const PATIENT_DETAILS_SUPERBILL_UPDATE = async (params) => {
    try {
        const response = await axiosInstance.put(`${baseUrl}/superbill/update`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

export const GENERATE_FORM_SUPERBILL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/generateClaimForm/generateFromSuperBill`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}








